import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PluginComponent } from '../plugin.component';
import { Inspection } from '../../shared/models/index';
import { BasePlugin } from '../base-plugin.component';

@Component({
    templateUrl: './executivesummary.component.html',
    standalone: false
})
export class ExecutiveSummaryPluginComponent extends BasePlugin implements OnInit {
  public plugin: any = {};
  inspectionId: string;
  public value: number;
  public inspection: Inspection;

  constructor(private route: ActivatedRoute, private cdRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.initData();
    this.value = this.plugin.config.Value;
    this.cdRef.detectChanges();
  }

  initData() {}

  getEditRoute() {
    return [
      this.inspection.isTemplate() ? this.templatesRoute : this.inspectionsRoute,
      this.inspection.id,
      'plugins',
      this.plugin.id,
      'executivesummary',
      'edit'
    ];
  }
}

PluginComponent.plugins['executivesummary'] = ExecutiveSummaryPluginComponent;
